import {
    CustomData,
    PerformanceDatapoint,
    getMailAriaTenantTokens,
    lazyLogDatapoint,
} from 'owa-analytics';
import UsageDatapoint from 'owa-analytics/lib/datapoints/UsageDatapoint';

const CalendarDatapointOptions = {
    tenantTokens: getMailAriaTenantTokens(),
    isCore: true,
};

export function logCalendarUsage(
    eventName: string,
    customData?: CustomData,
    cosmosOnlyData?: string
) {
    let datapoint = new UsageDatapoint(eventName, customData, CalendarDatapointOptions);
    if (cosmosOnlyData) {
        datapoint.addCosmosOnlyData(cosmosOnlyData);
    }
    lazyLogDatapoint.importAndExecute(datapoint);
}

export function createCalendarPerfDatapoint(eventName: string) {
    return new PerformanceDatapoint(eventName, CalendarDatapointOptions);
}
